import * as Yup from 'yup';
export const initialWorkflowStatusValues = () => ({
    description: '',
    workflowType: '',
    enumId: '',
});
export const workflowStatusSchema = Yup.object().shape({
    description: Yup.string(),
    workflowType: Yup.string(),
});
//# sourceMappingURL=workflow-status.js.map